//import { Router } from 'router5'
import createRouter from 'router5'
import browserPlugin from 'router5-plugin-browser'

import LogMiddlewareFactory from './middleware/log'
import AuthorizeMiddlewareFactory from './middleware/authorize'
import RedirectMiddlewareFactory from './middleware/redirect'
import TriggerMiddlewareFactory from './middleware/trigger'

import {
  AppRoute,
} from '../types/router'

import {
  RootState,
} from '../types/store'

const authorizeMiddleware = AuthorizeMiddlewareFactory()
const logMiddleware = LogMiddlewareFactory()
const redirectMiddleware = RedirectMiddlewareFactory()
const triggerMiddleware = TriggerMiddlewareFactory()

const Router = (routes: AppRoute[]) => {
  const router = createRouter(routes, {
    defaultRoute: 'notfound',
    queryParamsMode: 'loose',
  })

  router.usePlugin(browserPlugin({}))
  router.useMiddleware(authorizeMiddleware(routes))
  router.useMiddleware(logMiddleware(routes))
  router.useMiddleware(redirectMiddleware(routes))
  router.useMiddleware(triggerMiddleware(routes))

  return router
}

export default Router
